// import React, { useState, useEffect } from "react";
// import { useParams, useSearchParams } from "react-router-dom";
// import FiltersSidebar from "../components/Filters/FiltersSidebar";
// import ProductGrid from "../components/Products/ProductGrid";
// import { useProducts } from "../hooks/useProducts";

// const AllUserProducts = () => {
//   const { subCategorySlug } = useParams();
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [showMobileFilters, setShowMobileFilters] = useState(false);
//   const [pendingFilters, setPendingFilters] = useState(filters);


//   const [filters, setFilters] = useState({
//     categories: [],
//     brands: [],
//     colors: [],
//     sizes: [],
//     price: {
//       min: null,
//       max: null
//     }
//   });
//   const [sortBy, setSortBy] = useState("");

//   useEffect(() => {
//     const params = Object.fromEntries([...searchParams]);

//     setFilters({
//       categories: params.category ? [params.category] : [],
//       brands: params.brands ? params.brands.split(",") : [],
//       colors: params.colors ? params.colors.split(",") : [],
//       sizes: params.sizes ? params.sizes.split(",") : [],
//       price: {
//         min: params.min ? Number(params.min) : null,
//         max: params.max ? Number(params.max) : null
//       }
//     });
//   }, []);

//   useEffect(() => {
//     const params = {};

//     if (filters.categories.length)
//       params.category = filters.categories[0];

//     if (filters.brands.length)
//       params.brands = filters.brands.join(",");

//     if (filters.colors.length)
//       params.colors = filters.colors.join(",");

//     if (filters.sizes.length)
//       params.sizes = filters.sizes.join(",");

//     if (filters.price.min !== null && filters.price.max !== null) {
//       params.min = filters.price.min;
//       params.max = filters.price.max;
//     }

//     setSearchParams(params);
//   }, [filters]);

//   useEffect(() => {
//     if (subCategorySlug) {
//       setFilters((prev) => ({
//         ...prev,
//         categories: [subCategorySlug]
//       }));
//     }
//   }, [subCategorySlug]);

//   const showCategoryFilter = !subCategorySlug;
//   const { products, loading, brandCounts, priceBounds } = useProducts(filters);

// const sortOptions = [
//   { value: "", label: "Default" },
//   { value: "price-asc", label: "Price: Low to High" },
//   { value: "price-desc", label: "Price: High to Low" },
//   { value: "name-asc", label: "Name: A to Z" },
//   { value: "name-desc", label: "Name: Z to A" }
// ];

//   const sortedProducts = React.useMemo(() => {
//     if (!sortBy) return products;

//     const data = [...products];

//     switch (sortBy) {
//       case "price-asc":
//         return data.sort((a, b) => a.minPrice - b.minPrice);
//       case "price-desc":
//         return data.sort((a, b) => b.minPrice - a.minPrice);
//       case "name-asc":
//         return data.sort((a, b) =>
//           a.productName.localeCompare(b.productName)
//         );
//       case "name-desc":
//         return data.sort((a, b) =>
//           b.productName.localeCompare(a.productName)
//         );
//       default:
//         return data;
//     }
//   }, [products, sortBy]);


//   return (
//     <div className="mx-auto px-4 lg:px-8 py-6">
//       <div className="flex gap-6 relative">

//         {/* FILTER SIDEBAR */}
//         <aside className="hidden lg:block w-[280px] sticky top-4 self-start">
//           <FiltersSidebar
//             filters={filters}
//             setFilters={setFilters}
//             showCategoryFilter={showCategoryFilter}
//             brandCounts={brandCounts}
//             priceBounds={priceBounds}
//           />
//         </aside>



//         {/* PRODUCTS */}
//         <main className="flex-1 min-w-0">
//   {/* <div className="flex justify-between items-center mb-4">
//   <p className="text-sm text-gray-600">
//     Showing {products.length} results
//   </p>

//   <select
//     value={sortBy}
//     className="border rounded px-3 py-2 text-sm"
//     onChange={(e) => setSortBy(e.target.value)}
//   >
//     {sortOptions.map((opt) => (
//       <option key={opt.value} value={opt.value}>
//         {opt.label}
//       </option>
//     ))}
//   </select>
// </div> */}
//           {/* MOBILE STICKY HEADER */}
//           <div className="lg:hidden sticky top-0 z-20 bg-white border-b">
//             <div className="flex justify-between items-center p-4">
//               <span className="text-sm text-gray-600">
//                 Showing {products.length} results
//               </span>

//               <div className="flex items-center gap-2">
//                 {/* SORT */}
//                 <select
//                   value={sortBy}
//                   onChange={(e) => setSortBy(e.target.value)}
//                   className="border rounded px-2 py-1.5 text-sm"
//                 >
//                   <option value="">Default</option>
//                   <option value="price-asc">Price: Low to High</option>
//                   <option value="price-desc">Price: High to Low</option>
//                   <option value="name-asc">Name: A to Z</option>
//                   <option value="name-desc">Name: Z to A</option>
//                 </select>

//                 {/* FILTER BUTTON */}
//                 <button
//                   onClick={() => {
//                     setPendingFilters(filters);
//                     setShowMobileFilters(true);
//                   }}
//                   className="border rounded px-3 py-1.5 text-sm flex items-center gap-1"
//                 >
//                   ☰ Filter
//                   {(filters.brands.length +
//                     filters.colors.length +
//                     filters.sizes.length +
//                     (filters.price.min !== null ? 1 : 0)) > 0 && (
//                       <span className="bg-red-500 text-white text-xs rounded-full px-1.5">
//                         !
//                       </span>
//                     )}
//                 </button>
//               </div>
//             </div>
//           </div>

//           <ProductGrid products={sortedProducts} loading={loading} />
//         </main>

//         {showMobileFilters && (
//           <div
//             className="fixed inset-0 z-50 bg-black/40 flex items-end"
//             onClick={() => setShowMobileFilters(false)}
//           >
//             <div
//               className="bg-white w-full max-h-[85vh] rounded-t-2xl flex flex-col"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* HEADER */}
//               <div className="p-4 border-b flex justify-between items-center sticky top-0 bg-white">
//                 <h3 className="font-semibold text-lg">Filters</h3>
//                 <button onClick={() => setShowMobileFilters(false)}>✕</button>
//               </div>

//               {/* BODY */}
//               <div className="flex-1 overflow-y-auto p-4">
//                 <FiltersSidebar
//                   filters={pendingFilters}
//                   setFilters={setPendingFilters}
//                   showCategoryFilter={showCategoryFilter}
//                   brandCounts={brandCounts}
//                   priceBounds={priceBounds}
//                 />
//               </div>

//               {/* FOOTER */}
//               <div className="p-4 border-t flex gap-2 sticky bottom-0 bg-white">
//                 <button
//                   className="flex-1 bg-gray-100 py-3 rounded font-semibold"
//                   onClick={() => {
//                     setPendingFilters({
//                       categories: filters.categories,
//                       brands: [],
//                       colors: [],
//                       sizes: [],
//                       price: { min: null, max: null }
//                     });
//                   }}
//                 >
//                   Clear All
//                 </button>

//                 <button
//                   className="flex-1 bg-red-600 text-white py-3 rounded font-semibold"
//                   onClick={() => {
//                     setFilters(pendingFilters);
//                     setShowMobileFilters(false);
//                   }}
//                 >
//                   Apply Filters
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}


//       </div>
//     </div>
//   );
// };

// export default AllUserProducts;


import React, { useState, useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import FiltersSidebar from "../components/Filters/FiltersSidebar";
import ProductGrid from "../components/Products/ProductGrid";
import { useProducts } from "../hooks/useProducts";
import { SlidersHorizontal } from "lucide-react";
import SelectDropdown from "../customStyles/SelectDropdown";
import Breadcrumb from "../components/BreadCrumb";

const DEFAULT_FILTERS = {
  categories: [],
  brands: [],
  colors: [],
  sizes: [],
  price: {
    min: null,
    max: null
  },
  flags: {
    bestSeller: false,
    newArrivals: false
  }
};

const AllUserProducts = () => {
  const { subCategorySlug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  /* ---------------- STATES ---------------- */
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [pendingFilters, setPendingFilters] = useState(DEFAULT_FILTERS);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [sortBy, setSortBy] = useState("");

  /* ---------------- PRODUCTS ---------------- */
  const {
    products,
    loading,
    brandCounts,
    categoryCounts,
    priceBounds,
    availableSizes,
    colorOptions
  } = useProducts(filters);

  const showCategoryFilter = !subCategorySlug;

  /* ---------------- URL → FILTERS (ON LOAD) ---------------- */
  useEffect(() => {
    const params = Object.fromEntries([...searchParams]);

    const restoredFilters = {
      categories: params.category ? [params.category] : [],
      brands: params.brands ? params.brands.split(",") : [],
      colors: params.colors ? params.colors.split(",") : [],
      sizes: params.sizes ? params.sizes.split(",") : [],
      price: {
        min: params.min ? Number(params.min) : null,
        max: params.max ? Number(params.max) : null
      },
      flags: {
        bestSeller: params.bestSeller === "1",
        newArrivals: params.newArrivals === "1"
      }
    };

    setFilters(restoredFilters);
    setPendingFilters(restoredFilters);
  }, []); // eslint-disable-line

  /* ---------------- FILTERS → URL ---------------- */
  useEffect(() => {
    const params = {};

    if (filters.categories.length)
      params.category = filters.categories[0];

    if (filters.flags?.bestSeller) params.bestSeller = 1;
    if (filters.flags?.newArrivals) params.newArrivals = 1;

    if (filters.brands.length)
      params.brands = filters.brands.join(",");

    if (filters.colors.length)
      params.colors = filters.colors.join(",");

    if (filters.sizes.length)
      params.sizes = filters.sizes.join(",");

    if (filters.price.min !== null && filters.price.max !== null) {
      params.min = filters.price.min;
      params.max = filters.price.max;
    }

    setSearchParams(params);
  }, [filters, setSearchParams]);

  /* ---------------- SUBCATEGORY FROM ROUTE ---------------- */
  useEffect(() => {
    if (subCategorySlug) {
      setFilters((prev) => ({
        ...prev,
        categories: [subCategorySlug]
      }));
    }
  }, [subCategorySlug]);

  const sortOptions = [
    { value: "", label: "Default" },
    { value: "price-asc", label: "Price: Low to High" },
    { value: "price-desc", label: "Price: High to Low" },
    { value: "name-asc", label: "Name: A to Z" },
    { value: "name-desc", label: "Name: Z to A" }
  ];

  const getProductMinPrice = (product) => {
    let min = Infinity;

    product.variants?.forEach(v => {
      v.sizes?.forEach(s => {
        const price = Number(s.price);
        if (!isNaN(price)) {
          min = Math.min(min, price);
        }
      });
    });

    return min === Infinity ? 0 : min;
  };

  const sortedProducts = useMemo(() => {
    if (!sortBy) return products;

    const data = [...products];

    switch (sortBy) {
      case "price-asc":
        return data.sort(
          (a, b) => getProductMinPrice(a) - getProductMinPrice(b)
        );

      case "price-desc":
        return data.sort(
          (a, b) => getProductMinPrice(b) - getProductMinPrice(a)
        );

      case "name-asc":
        return data.sort((a, b) =>
          a.productName.localeCompare(b.productName)
        );

      case "name-desc":
        return data.sort((a, b) =>
          b.productName.localeCompare(a.productName)
        );

      default:
        return data;
    }
  }, [products, sortBy]);


  const breadcrumbItems = useMemo(() => {
    const items = [
      { label: "Home", path: "/" },
      { label: "Products", path: "/all-userproducts" }
    ];

    if (subCategorySlug) {
      // Convert slug → readable text
      const formatted = subCategorySlug
        .split("-")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");

      items.push({
        label: formatted,
        path: null // current page → not clickable
      });      
    }

    return items;
  }, [subCategorySlug]);


  /* ---------------- UI ---------------- */
  return (
    <div className="mx-auto px-4 lg:px-8 py-6 bg-white">
        {/* BREADCRUMB */}
      <div className="mb-2 block lg:hidden">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <div className="flex gap-6 relative">

        {/* DESKTOP FILTER */}
        <aside className="hidden lg:block w-[280px] sticky top-4 self-start">
          <FiltersSidebar
            filters={filters}
            setFilters={setFilters}
            showCategoryFilter={showCategoryFilter}
            brandCounts={brandCounts}
            categoryCounts={categoryCounts}
            priceBounds={priceBounds}
            availableSizes={availableSizes}
            colorOptions={colorOptions}
            preserveCategories={subCategorySlug ? [subCategorySlug] : []}
          />
        </aside>

        {/* PRODUCTS */}
        <main className="flex-1 min-w-0">
                <div className="mb-2 hidden lg:block">
                <Breadcrumb items={breadcrumbItems} />
              </div>
          {/* DESKTOP HEADER */}
          <div className="hidden lg:flex justify-between items-center mb-4 pb-3">
            <p className="text-sm text-gray-600">
              Showing <span className="font-semibold">{products.length}</span> results
            </p>

            <div className="flex items-center gap-2">
              <span className="text-sm font-medium whitespace-nowrap">
                Sort By
              </span>

              <SelectDropdown
                value={sortBy}
                onChange={setSortBy}
                options={sortOptions}
                labelKey="label"
                valueKey="value"
                placeholder="Default"
                parentClassName="min-w-[150px]"
                ChildClassName="border rounded px-3 py-1.5 text-sm h-[38px] bg-white whitespace-nowrap"
              />
            </div>
          </div>


          {/* MOBILE STICKY BAR */}
          <div className="lg:hidden sticky top-0 z-20 bg-white mb-4 shadow-sm rounded-b">
            <div className="flex justify-between items-center p-4 gap-2">
              <span className="text-sm text-gray-600">
                Showing {products.length} results
              </span>

              <div className="flex items-center gap-2">
                <SelectDropdown
                  value={sortBy}
                  onChange={setSortBy}
                  options={sortOptions}
                  labelKey="label"
                  valueKey="value"
                  placeholder="Sort By"
                  parentClassName="w-[160px]"
                  ChildClassName="border rounded px-2 py-1.5 text-sm bg-white whitespace-nowrap"
                  dropdownClassName="min-w-[220px]"
                />

                <button
                  onClick={() => {
                    setPendingFilters(filters);
                    setShowMobileFilters(true);
                  }}
                  className="border rounded px-2 py-2 text-sm"
                >
                  <SlidersHorizontal size={24} />
                </button>
              </div>
            </div>
          </div>

          <ProductGrid products={sortedProducts} loading={loading} />
        </main>

        {/* MOBILE FILTER MODAL */}
        {showMobileFilters && (
          <div
            className="fixed inset-0 z-50 bg-black/40 flex items-end"
            onClick={() => setShowMobileFilters(false)}
          >
            <div
              className="bg-white w-full max-h-[85vh] rounded-t-2xl flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-4 border-b flex justify-between">
                <h3 className="font-semibold">Filters</h3>
                <button onClick={() => setShowMobileFilters(false)}>✕</button>
              </div>

              <div className="flex-1 overflow-y-auto p-4">
                <FiltersSidebar
                  filters={pendingFilters}
                  setFilters={setPendingFilters}
                  showCategoryFilter={showCategoryFilter}
                  brandCounts={brandCounts}
                  priceBounds={priceBounds}
                  availableSizes={availableSizes}
                  colorOptions={colorOptions}
                  preserveCategories={subCategorySlug ? [subCategorySlug] : []}
                />
              </div>

              <div className="p-4 border-t flex gap-2">
                <button
                  className="flex-1 bg-gray-100 py-3 rounded font-semibold"
                  onClick={() => setPendingFilters({
                    ...DEFAULT_FILTERS,
                    categories: filters.categories
                  })}
                >
                  Clear All
                </button>

                <button
                  className="flex-1 bg-red-600 text-white py-3 rounded font-semibold"
                  onClick={() => {
                    setFilters(pendingFilters);
                    setShowMobileFilters(false);
                  }}
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AllUserProducts;
